LN.LocalStorage = new (function (Config) {
    var self = this;

    self.removeItem = function (key) {
        localStorage.removeItem(key);
    }

    self.setExpiredItem = function (key, value) {
        var item = {
            'value': value,
            'expiration': new Date()
        };

        localStorage.setItem(key, JSON.stringify(item));
    }

    self.setItem = function (key, value) {
        localStorage.setItem(key, JSON.stringify(value));
    }
    self.getItem = function (key) {
        return JSON.parse(localStorage.getItem(key));
    }

    self.renew = function (key) {
        var item = self.getItem(key);
        if (item.expiration) {
            item.expiration = new Date();

            localStorage.setItem(key, JSON.stringify(item));
        }
    }

    self.checkExpiration = function (key, expiration) {
        var item = self.getItem(key);
        if (item.expiration) {
            var itemexpiration = new Date(item.expiration);

            var lifetime = expiration || Config.StorageExpiration;

            if ((new Date() - itemexpiration) < lifetime) {
                return item;
            } else {
                return null;
            }
        }
        return null;
    }

    self.checkIfExists = function (key) {
        return (localStorage.getItem(key) !== null);
    }

})(LN.Config);


// WEBPACK FOOTER //
// ./Statics/scripts/common/localstorage.js